(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-cards"] && !Shopify.designMode) return;
  try {
    
/* JS: no Liquid inside. Infinite slider (clone), arrows, swipe, autoplay toggle */
(function () {
  var AUTOPLAY = false;
  var AUTOPLAY_INTERVAL = 3600;
  
  function initAll() {
    var sections = Array.from(document.querySelectorAll('.rk-mc-section'));
    sections.forEach(initSection);
  }
  
  function initSection(section) {
    if (!section || section.dataset.rkMcInited) return;
    section.dataset.rkMcInited = 'true';
    
    var list = section.querySelector('.rk-mc-list');
    var left = section.querySelector('.rk-mc-arrow--left');
    var right = section.querySelector('.rk-mc-arrow--right');
    var origItems = list ? Array.from(list.children) : [];
    var origCount = origItems.length;
    
    if (!list || origCount === 0) return;
    
    // visible items
    var dataVis = parseInt(section.dataset.rkVisible || NaN);
    var visRaw = getComputedStyle(section).getPropertyValue('--rk-mc-visible-items').trim();
    var vis = Number.isInteger(dataVis) ? dataVis : (parseInt(visRaw) || 4);
    section.style.setProperty('--rk-mc-visible-items', vis);
    
    // clone for infinite
    var firstClones = [], lastClones = [];
    for (var i = 0; i < vis; i++) {
      var lastIndex = (origCount - vis + i) % origCount;
      var cloneLast = origItems[lastIndex].cloneNode(true);
      cloneLast.classList.add('rk-mc-clone');
      lastClones.push(cloneLast);
      
      var cloneFirst = origItems[i % origCount].cloneNode(true);
      cloneFirst.classList.add('rk-mc-clone');
      firstClones.push(cloneFirst);
    }
    
    lastClones.forEach(function (n) { list.insertBefore(n, list.firstChild); });
    firstClones.forEach(function (n) { list.appendChild(n); });
    
    var total = list.children.length;
    var startIndex = vis;
    var index = startIndex;
    
    // helper width
    function stepSize() {
      var it = list.querySelector('.rk-mc-item');
      if (!it) return section.offsetWidth;
      var rect = it.getBoundingClientRect();
      var style = getComputedStyle(list);
      var gap = parseFloat(style.gap || style.columnGap || 0) || 0;
      return Math.round(rect.width + gap);
    }
    
    // immediate translate
    function setImmediate(i) {
      var s = stepSize();
      list.style.transition = 'none';
      list.style.transform = 'translate3d(' + (-s * i) + 'px,0,0)';
      setTimeout(function () { list.style.transition = ''; }, 20);
    }
    
    // animated translate
    function setAnimated(i) {
      var s = stepSize();
      list.style.transform = 'translate3d(' + (-s * i) + 'px,0,0)';
    }
    
    // transitionend -> fix wrap
    list.addEventListener('transitionend', function () {
      if (index >= startIndex + origCount) {
        index = startIndex;
        setImmediate(index);
      } else if (index < startIndex) {
        index = startIndex + origCount - 1;
        setImmediate(index);
      }
    });
    
    // controls
    left && left.addEventListener('click', function () { index = index - 1; setAnimated(index); resetAutoplay(); });
    right && right.addEventListener('click', function () { index = index + 1; setAnimated(index); resetAutoplay(); });
    
    // keyboard
    section.tabIndex = 0;
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') left && left.click();
      if (e.key === 'ArrowRight') right && right.click();
    });
    
    // swipe
    (function () {
      var startX = 0, dist = 0, startTime = 0, threshold = 30, allowed = 500;
      section.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.pageX; startTime = Date.now();
      }, {passive:true});
      
      section.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        dist = t.pageX - startX;
        var elapsed = Date.now() - startTime;
        if (elapsed <= allowed && Math.abs(dist) >= threshold) {
          if (dist < 0) { index = index + 1; } else { index = index - 1; }
          setAnimated(index); resetAutoplay();
        }
      }, {passive:true});
    })();
    
    // equalize heights to keep cards consistent
    function equalize() {
      var cards = Array.from(section.querySelectorAll('.rk-mc-card'));
      if (!cards.length) return;
      cards.forEach(function (c) { c.style.minHeight = '0'; });
      var max = cards.reduce(function (acc, el) {
        var h = Math.round(el.getBoundingClientRect().height);
        return h > acc ? h : acc;
      }, 0);
      if (max > 0) cards.forEach(function (c) { c.style.minHeight = max + 'px'; });
    }
    
    // recalc on resize/images
    var rto;
    function recalc() {
      list.style.transition = 'none';
      setImmediate(index);
      equalize();
      setTimeout(function () { list.style.transition = ''; }, 20);
    }
    
    window.addEventListener('resize', function () { clearTimeout(rto); rto = setTimeout(recalc, 120); });
    
    var imgs = Array.from(section.querySelectorAll('img'));
    var loaded = 0;
    if (imgs.length === 0) recalc();
    imgs.forEach(function (img) {
      if (img.complete) { loaded++; if (loaded === imgs.length) recalc(); return; }
      img.addEventListener('load', function () { loaded++; if (loaded === imgs.length) recalc(); });
      img.addEventListener('error', function () { loaded++; if (loaded === imgs.length) recalc(); });
    });
    
    // initial
    setTimeout(function () { recalc(); setImmediate(index); }, 60);
    
    // autoplay
    var timer = null;
    function startAuto() { if (!AUTOPLAY) return; stopAuto(); timer = setInterval(function () { index = index + 1; setAnimated(index); }, AUTOPLAY_INTERVAL); }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function resetAutoplay() { stopAuto(); startAuto(); }
    section.addEventListener('mouseover', stopAuto);
    section.addEventListener('mouseout', startAuto);
    startAuto();
  }
  
  // run when DOM ready
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
/* ---- JS (no Liquid inside) ---- */
(function () {
  var AUTOPLAY = true;
  var AUTOPLAY_INTERVAL = 4000;
  function waitFor(selector, timeout, cb) {
    var start = Date.now();
    (function check() {
      var el = document.querySelector(selector);
      if (el) return cb(null, el);
      if (Date.now() - start > (timeout || 3000)) return cb(new Error('timeout'));
      setTimeout(check, 30);
    })();
  }
  // init existing or wait for first
  var existing = Array.from(document.querySelectorAll('.rk-ps-section'));
  if (existing.length) existing.forEach(initSection);
  else waitFor('.rk-ps-section', 3000, function(err, s){ if (s) initSection(s); });
  function initSection(section) {
    if (!section || section.dataset.rkInited) return;
    section.dataset.rkInited = 'true';
    var list = section.querySelector('.rk-ps-list');
    var leftBtn = section.querySelector('.rk-ps-arrow--left');
    var rightBtn = section.querySelector('.rk-ps-arrow--right');
    var origItems = list ? Array.from(list.children) : [];
    var origCount = origItems.length;
    if (!list || origCount === 0) return;
    // visible items
    var dataVis = parseInt(section.dataset.rkVisible || NaN);
    var visRaw = getComputedStyle(section).getPropertyValue('--rk-visible-items').trim();
    var vis = Number.isInteger(dataVis) ? dataVis : (parseInt(visRaw) || 4);
    section.style.setProperty('--rk-visible-items', vis);
    // If mobile (scrollable), skip cloning logic or handle differently
    // For now, we apply cloning only if not touch/mobile layout logic overrides it
    // But CSS media query hides arrows on mobile, so let's keep logic robust.
    // CLONE for infinite effect
    var firstClones = [];
    var lastClones = [];
    for (var i = 0; i < vis; i++) {
      // last clones (prepend)
      var srcIndex = (origCount - vis + i) % origCount;
      var cloneLast = origItems[srcIndex].cloneNode(true);
      cloneLast.classList.add('rk-ps-clone');
      cloneLast.setAttribute('aria-hidden', 'true');
      lastClones.push(cloneLast);
      // first clones (append)
      var cloneFirst = origItems[i % origCount].cloneNode(true);
      cloneFirst.classList.add('rk-ps-clone');
      cloneFirst.setAttribute('aria-hidden', 'true');
      firstClones.push(cloneFirst);
    }
    // prepend lastClones
    lastClones.forEach(function (n) { list.insertBefore(n, list.firstChild); });
    // append firstClones
    firstClones.forEach(function (n) { list.appendChild(n); });
    var total = list.children.length; // orig + 2*vis
    var startIndex = vis; // index position where real items begin
    var index = startIndex;
    // helper to get item width + gap
    function getStep() {
      var item = list.querySelector('.rk-ps-item');
      if (!item) return 0;
      var rect = item.getBoundingClientRect();
      var style = getComputedStyle(list);
      var gap = parseFloat(style.gap || style.columnGap || 0) || 0;
      return rect.width + gap;
    }
    // set initial translate to show startIndex
    function setTranslateImmediate(i) {
      var step = getStep();
      if (!step) return;
      list.style.transition = 'none';
      list.style.transform = 'translate3d(' + (-step * i) + 'px,0,0)';
      // force reflow
      list.offsetHeight; 
      setTimeout(function () { list.style.transition = ''; }, 20);
    }
    // set transform with animation
    function setTranslateAnimated(i) {
      var step = getStep();
      list.style.transform = 'translate3d(' + (-step * i) + 'px,0,0)';
    }
    // transitionend handler for infinite jump
    list.addEventListener('transitionend', function () {
      // if moved past last real (index >= startIndex + origCount) -> jump to startIndex
      if (index >= startIndex + origCount) {
        index = startIndex + (index - (startIndex + origCount)); // preserve offset if multiple
        // simplified:
        index = startIndex;
        setTranslateImmediate(index);
      }
      // if moved left beyond first real (index < startIndex) -> jump to last real
      if (index < startIndex) {
        index = startIndex + origCount - 1;
        setTranslateImmediate(index);
      }
    });
    // equalize heights
    function equalize() {
      var cards = Array.from(section.querySelectorAll('.rk-ps-card'));
      if (!cards.length) return;
      cards.forEach(function (c) { c.style.minHeight = '0'; });
      var max = cards.reduce(function (acc, el) {
        var h = el.getBoundingClientRect().height;
        return h > acc ? h : acc;
      }, 0);
      if (max > 0) cards.forEach(function (c) { c.style.minHeight = max + 'px'; });
    }
    // controls
    leftBtn && leftBtn.addEventListener('click', function () { index = index - 1; setTranslateAnimated(index); resetAutoplay(); });
    rightBtn && rightBtn.addEventListener('click', function () { index = index + 1; setTranslateAnimated(index); resetAutoplay(); });
    // keyboard
    section.tabIndex = 0;
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') leftBtn && leftBtn.click();
      if (e.key === 'ArrowRight') rightBtn && rightBtn.click();
    });
    // swipe
    (function () {
      var startX = 0, dist = 0, threshold = 30, allowedTime = 500, startTime = 0;
      section.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.pageX; startTime = Date.now(); dist = 0;
      }, {passive:true});
      section.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        dist = t.pageX - startX;
        var elapsed = Date.now() - startTime;
        if (elapsed <= allowedTime && Math.abs(dist) >= threshold) {
          if (dist < 0) { index = index + 1; } else { index = index - 1; }
          setTranslateAnimated(index); resetAutoplay();
        }
      }, {passive:true});
    })();
    // recalc and initial placement
    function recalc() {
      // small reset to compute sizes
      list.style.transition = 'none';
      setTranslateImmediate(index);
      equalize();
      setTimeout(function () { list.style.transition = ''; }, 30);
    }
    // images loaded
    var imgs = Array.from(section.querySelectorAll('img'));
    var loaded = 0;
    if (imgs.length === 0) recalc();
    imgs.forEach(function (img) {
      if (img.complete) { loaded++; if (loaded === imgs.length) recalc(); return; }
      img.addEventListener('load', function () { loaded++; if (loaded === imgs.length) recalc(); });
      img.addEventListener('error', function () { loaded++; if (loaded === imgs.length) recalc(); });
    });
    // resize
    var rto;
    window.addEventListener('resize', function () { clearTimeout(rto); rto = setTimeout(recalc, 120); });
    // initial set
    setTimeout(function () { recalc(); setTranslateImmediate(index); }, 60);
    // AUTOPLAY
    var autoplayTimer = null;
    function startAutoplay() {
      if (!AUTOPLAY) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () { index = index + 1; setTranslateAnimated(index); }, AUTOPLAY_INTERVAL);
    }
    function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
    function resetAutoplay() { stopAutoplay(); startAutoplay(); }
    // pause on hover/focus
    section.addEventListener('mouseover', stopAutoplay);
    section.addEventListener('mouseout', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);
    // start autoplay
    startAutoplay();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
